import { ZAEHLER_ART_LABEL, type Protokoll } from './domain/types';

export interface Pruefpunkt {
	id: string;
	bereich: 'Räume' | 'Zähler' | 'Schlüssel' | 'Unterschriften';
	text: string;
}

/**
 * Bewusst Hinweise statt harter Validierung: Eine Wohnung kann legitimerweise
 * keine erfassten Schlüssel oder Zähler haben. Die App warnt, der Mensch
 * entscheidet und kann das Protokoll trotzdem abschließen.
 */
export function pruefeVollstaendigkeit(protokoll: Protokoll): Pruefpunkt[] {
	const punkte: Pruefpunkt[] = [];

	if (protokoll.raeume.length === 0) {
		punkte.push({ id: 'keine-raeume', bereich: 'Räume', text: 'Es wurde noch kein Raum erfasst.' });
	}

	for (const raum of protokoll.raeume) {
		for (const mangel of raum.maengel) {
			if (mangel.zustand === 'mangel' && mangel.fotoIds.length === 0) {
				punkte.push({
					id: `mangel-foto-${mangel.id}`,
					bereich: 'Räume',
					text: `${raum.name}: „${mangel.gegenstand}“ hat noch kein Beweisfoto.`
				});
			}
		}
	}

	for (const zaehler of protokoll.zaehler) {
		const label = ZAEHLER_ART_LABEL[zaehler.art];
		if (!zaehler.stand.trim()) {
			punkte.push({ id: `zaehler-stand-${zaehler.id}`, bereich: 'Zähler', text: `${label}: Zählerstand fehlt.` });
		}
		if (zaehler.fotoIds.length === 0) {
			punkte.push({ id: `zaehler-foto-${zaehler.id}`, bereich: 'Zähler', text: `${label}: Beweisfoto fehlt.` });
		}
	}

	if (protokoll.schluessel.length === 0) {
		punkte.push({
			id: 'keine-schluessel',
			bereich: 'Schlüssel',
			text: 'Es wurden keine übergebenen Schlüssel dokumentiert.'
		});
	}

	if (protokoll.beteiligte.length === 0) {
		punkte.push({
			id: 'keine-beteiligten',
			bereich: 'Unterschriften',
			text: 'Es wurden noch keine Beteiligten erfasst.'
		});
	} else {
		for (const beteiligter of protokoll.beteiligte) {
			if (!beteiligter.unterschrift) {
				punkte.push({
					id: `unterschrift-${beteiligter.id}`,
					bereich: 'Unterschriften',
					text: `${beteiligter.name} hat noch nicht unterschrieben.`
				});
			}
		}
	}

	return punkte;
}
